import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { Page } from "../../shared/models/Page";
import { CasillaDteRecibido } from "../../models/CasillaDteRecibidos/CasillaDteRecibido";
import { PagedResponse } from "../../shared/models/PagedResponse";
import { CasillaDteRecibidoFilter } from "../../models/CasillaDteRecibidos/CasillaDteRecibidoFilter";
import { EjemploCasillaDteRecibido } from "src/app/models/CasillaDteRecibidos/EjemploCasillasDteRecibido";

@Injectable({
   providedIn: "root",
})
export class CasillaDteRecibidoService {
   private REST_API_SERVER = environment.backend_server + "/CasillaCorreoDteRecibido";
   private auth = {};
   constructor(private http: HttpClient) {}

   public getDataByPage(filtro: CasillaDteRecibidoFilter, page: Page): Observable<PagedResponse<CasillaDteRecibido>> {
      return this.http.get<PagedResponse<CasillaDteRecibido>>(this.REST_API_SERVER + "/list/filter?Correo=" + (filtro.correo != undefined ? filtro.correo : "") + "&TipoProveedorCorreoId=" + (filtro.tipoProveedorCorreoId != undefined ? filtro.tipoProveedorCorreoId : "") + "&EmisorId=" + (filtro.emisorId != undefined ? filtro.emisorId : "") + "&Activo=" + filtro.activo + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
   }
   getCasillasDteRecibidoByEmisor(idEmisor: string): Observable<Response<CasillaDteRecibido[]>> {
      return this.http.get<Response<CasillaDteRecibido[]>>(this.REST_API_SERVER + "/getCasillasDteRecibidoByEmisor/" + idEmisor);
   }
   getCasillaDteRecibidoByEmisor(idEmisor: string): Observable<Response<CasillaDteRecibido>> {
      return this.http.get<Response<CasillaDteRecibido>>(this.REST_API_SERVER + "/getCasillaDteRecibidoByEmisor/" + idEmisor);
   }
   deactivate(casillaId: string): Observable<Response<boolean>> {
      return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/deactivateCasillaDteRecibido/" + casillaId);
   }

   activate(ent: CasillaDteRecibido): Observable<Response<boolean>> {
      return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/activateCasillaDteRecibido", ent);
   }

   update(casillaDteRecibido: CasillaDteRecibido): Observable<Response<CasillaDteRecibido>> {
      return this.http.post<Response<CasillaDteRecibido>>(this.REST_API_SERVER + "/updateCasillaDteRecibido", casillaDteRecibido);
   }

   add(ent: CasillaDteRecibido): Observable<Response<CasillaDteRecibido>> {
      return this.http.post<Response<CasillaDteRecibido>>(this.REST_API_SERVER + "/addCasillaDteRecibido", ent);
   }

   downloadTemplate(): Observable<Response<EjemploCasillaDteRecibido[]>> {
      return this.http.get<Response<EjemploCasillaDteRecibido[]>>(this.REST_API_SERVER + "/downloadTemplate");
   }
   downloadJson(casillaId: string): Observable<Response<string>> {
      return this.http.get<Response<string>>(this.REST_API_SERVER + "/downloadJson/" + casillaId);
   }
}
